import BaseAPI from "./BaseAPI";

class ProspectAPI extends BaseAPI {
	
    index = () => {
        var promise = this.init().post("/account/prospect", {});
        return promise;
    };

    getWorkprocesses = () => {
        var promise = this.init().post("/account/wp/search", {});
        return promise;
    };

    createDossier = (data) => {
        var promise = this.init().get("/account/dossiers/create/"+data.id);
        return promise;
    };

    get = (data) => {
        var promise = this.init().get("/account/prospects", data);
        return promise;
    };

    delete = (data) => {
        var promise = this.init().delete("/account/communicationcycle/"+data);
        return promise;
    };

    new = (eventType) => {
        
        var promise = this.init().get("/account/communicationcycle/new/"+eventType.toLowerCase());
        return promise;
    };

    store = (data) => {
        var promise = this.init().post("/account/communicationcycle", data);
        return promise;
    };
	
}

export default new ProspectAPI();